import React from 'react'
import DOMPurify from 'dompurify'

const MarkupViewer = ({htmlString}) => {
  
 const processLinks = (htmlString) => {
  // const cleanHtml = DOMPurify.sanitize(htmlString)
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    const links = doc.querySelectorAll('a');

    links.forEach(link => {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });

    return doc.body.innerHTML;
  };
  return (
    <div dangerouslySetInnerHTML={{ __html: processLinks(htmlString) }} />
  )
}

export default MarkupViewer